export default class GoogleTag {
  static enabled = false;

  static init(measurementId) {
    if (!measurementId || this.enabled) {
      return;
    }
    this.enabled = true;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', measurementId, {
      cookie_flags: 'SameSite=None;Secure',
      send_page_view: false,
    });
  }

  static pageView() {
    if (!this.enabled) {
      return;
    }
    window.gtag('event', 'page_view', { page_location: window.location.href });
  }
}
